"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rows = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const utils_1 = require("./utils");
const MaxStack = (0, app_1.styled)(ui_1.Stack) `
  width: 100%;
`;
function Rows({ rows, spacing = 'medium' }) {
    return ((0, jsx_runtime_1.jsx)(MaxStack, Object.assign({ kind: "vertical", spacing: spacing }, { children: rows.sort(utils_1.sortByOrder).map((row) => {
            return (0, jsx_runtime_1.jsx)(utils_1.SectionElement, { element: row }, row.id);
        }) })));
}
exports.Rows = Rows;
